module.exports = __webpack_public_path__ + "static/p-logo--company-eb261612ee5153763281bb497bd880e1.png";